var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "vuetify-wrapper" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "nudge-width": "360",
            "offset-x": "",
            "content-class": "v-application",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on: menu, attrs }) {
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "360" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on: tooltip }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "approval-automation-block-btn",
                                        attrs: {
                                          loading: _vm.loading,
                                          "min-width": "30",
                                          small: "",
                                          title: _vm.title,
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    { ...tooltip, ...menu }
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          color: _vm.isBlocked
                                            ? "red"
                                            : "green",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.isBlocked
                                                ? "mdi-lock"
                                                : "mdi-lock-open-variant"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.title))])]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function ($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen",
          },
        },
        [
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(
                  _vm._s(
                    _vm.isBlocked ? "Automatik entsperren" : "Automatik sperren"
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.isBlocked
                    ? _c("p", [
                        _vm._v(
                          "\n                    Automatische Erinnerungen, Freigabe und ApoBilanz-Weitergabe sind pausiert.\n                "
                        ),
                      ])
                    : _c("v-text-field", {
                        attrs: {
                          label: "Sperrgrund (optional)",
                          maxlength: "500",
                          counter: "500",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.reason,
                          callback: function ($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason",
                        },
                      }),
                  _vm._v(" "),
                  _vm.isBlocked && _vm.currentReason
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "\n                    Grund: " +
                            _vm._s(_vm.currentReason) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.menuOpen = false
                        },
                      },
                    },
                    [_vm._v("Abbrechen")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "approval-automation-block-save-btn",
                      attrs: {
                        color: _vm.isBlocked ? "green" : "red",
                        outlined: "",
                        small: "",
                      },
                      on: { click: _vm.save },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.isBlocked ? "Entsperren" : "Sperren") +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }